<template>
  <div class="all">
    <!-- 區塊一 -->
    <section id="section1" class="section1">
      <subNav></subNav>
      <div class="custom-container">
        <div class="page-header" data-aos="zoom-in" data-aos-duration="800">
          <h3 class="title">CIS/Logo</h3>
          <ul class="content">
            <li>品牌標誌設計</li>
            <li>輔助圖形設計</li>
            <li>相關延伸物設計</li>
            <li>品牌識別規範</li>
            <li>品牌識別相關諮詢</li>
          </ul>
        </div>
      </div>
    </section>
    <!-- 區塊二 -->
    <section class="section2">
      <div class="custom-container">
        <div class="custom-row">
          <div class="custom-grid">
            <div class="project-card" data-aos="zoom-in" data-aos-duration="800">
              <div class="project-img"></div>
              <div class="project-text">201810_愛無限托嬰中心_CIS</div>
            </div>
          </div>
          <div class="custom-grid">
            <div class="project-card" data-aos="zoom-in" data-aos-duration="800">
              <div class="project-img"></div>
              <div class="project-text">201805_LEAF KEY_LOGO</div>
            </div>
          </div>
          <div class="custom-grid">
            <div class="project-card" data-aos="zoom-in" data-aos-duration="800">
              <div class="project-img"></div>
              <div class="project-text">201811_天下茶倉_CIS</div>
            </div>
          </div>
          <div class="custom-grid">
            <div class="project-card" data-aos="zoom-in" data-aos-duration="800">
              <div class="project-img"></div>
              <div class="project-text">201807_豆豆幼兒園_LOGO</div>
            </div>
          </div>
        </div>
        <div class="more">
              <a href="javascript:;" class="btn rounded-0">MORE</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import subNav from './subNav.vue';
  export default {
    name: 'Service-cis',
    components: {
      subNav
    },
    data() {
      return {

      }
    }
  }

</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/common.scss';
  @import 'src/assets/scss/service/cis/section1.scss';
  @import 'src/assets/scss/service/cis/section2.scss';

</style>



// WEBPACK FOOTER //
// src/components/CIS.vue